module.exports = __webpack_public_path__ + "img/times-circle-regular.33f6f406.svg";